// extracted by mini-css-extract-plugin
export default {"root":"ExerciseStuList_root__QbWRg","search":"ExerciseStuList_search__vgm-f"};